import { GDPR_WEB_LOCALES } from '@/constants/web-locales.constant';
import type { WebLocale } from '@/enums/web-locale';

function isGDPRCountry(webLocale: WebLocale) {
	return GDPR_WEB_LOCALES.includes(webLocale);
}

export { isGDPRCountry };
